<template>
  <ContentGeneratorElementsText :content="content" />
</template>

<script>
import ContentGeneratorElementsText from '../elements/Text.vue'
import { contentFindContent } from '../../../plugins/content'
export default {
  components: {
    ContentGeneratorElementsText
  },
  props: {
    value: { type: Object, default: null }
  },
  computed: {
    content () {
      return contentFindContent(this.value?.content, 'default')
    }
  }
}

</script>
